import { render, staticRenderFns } from "./goodsCoverSetting.vue?vue&type=template&id=23214040&scoped=true"
import script from "./goodsCoverSetting.vue?vue&type=script&lang=js"
export * from "./goodsCoverSetting.vue?vue&type=script&lang=js"
import style0 from "./goodsCoverSetting.vue?vue&type=style&index=0&id=23214040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23214040",
  null
  
)

export default component.exports